// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import {store} from './store/store'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'zI5u0s34igLNQHBcO3ax3YQNxrfMOv9f'
})
Vue.use(Lazyload);
Vue.use(Vant);
Vue.use(VideoPlayer)
Vue.prototype.axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store:store,
  axios,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js